import utils from './utils';
import models from '../model/models';
import capitalize from 'lodash.capitalize';

let gramUtils = new function() {
	this.displayValue = (microgram) => {
		return this.convertValue(microgram) + ' ' + this.deriveUnit(microgram);
	};

	this.convertValue = (microgram, type) => {
		let val = Math.abs(parseFloat(microgram));
		let num = parseFloat(microgram);
		let retVal = 0;
		if (val >= 1000000) {
			retVal = num / 1000000;
		} else if (val >= 1000) {
			retVal = num / 1000;
		} else {
			retVal = num;
		}
		if (Math.round(retVal) !== retVal) {
			retVal = retVal.toFixed(2);
		}
		return utils.display_number(retVal);
	};

	this.forceMiligram = (microgram) => {
		return microgram / 1000;
	};

	this.deriveUnit = (microgram) => {
		let val = Math.abs(parseFloat(microgram));
		if (val >= 1000000) {
			return 'g';
		} else if (val >= 1000) {
			return 'mg';
		} else if (val > 0) {
			return 'mcg';
		} else {
			return '';
		}
	};
}();

export const getDrugName = (type) => {
	let typeData = models.drug_type.obj(type);
	if (!typeData) {
		return type
			.split('_')
			.map(capitalize)
			.join(' ');
	}
	return typeData.name;
};

export const getUnit = (type) => {
	let typeData = models.drug_type.obj(type);
	if (!typeData) {
		if (type) console.log(type);
		return '';
	}
	return typeData.unit_of_measurement || 'mg';
};
export const getDisplayUnit = (type) => {
	let typeData = models.drug_type.obj(type);
	if (!typeData) {
		if (type) console.log(type);
		return '';
	}
	return typeData.display_unit_of_measurement || typeData.unit_of_measurement || 'mg';
};
export const inPreferredUnit = (mcgQuantity, type) => {
	if (getUnit(type) === 'mg') {
		return mcgQuantity / 1000;
	} else if (getUnit(type) === 'g') {
		return mcgQuantity / (1000 * 1000);
	}
	return mcgQuantity;
};

export default gramUtils;



// WEBPACK FOOTER //
// ./src/utils/gramUtils.js